import * as types from "./actionTypes";

export const setCumulativeMemberByYear = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_CUMULATIVE_MEMBER_BY_YEAR,
      key,
      yearKey,
      amount,
    });
  };
};

export const setCumulativeMemberByMonths = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_CUMULATIVE_MEMBER_BY_MONTHS,
      key,
      yearKey,
      amount,
    });
  };
};

export const replaceCumulativeMemberYears = (key, payload) => {
  return (dispatch) => {
    return dispatch({
      type: types.REPLACE_CUMULATIVE_MEMBER_YEARS,
      key,
      payload,
    });
  };
};

export const resetCumulativeMemberReducer = () => {
  return (dispatch) => {
    return dispatch({
      type: types.RESET_CUMULATIVE_MEMBER_REDUCER,
    });
  };
};
